<template>
  <div class="personal-center-container">
    <!-- 面包屑导航 -->
    <a-breadcrumb style="margin-bottom: 16px">
      <a-breadcrumb-item>个人中心</a-breadcrumb-item>
      <a-breadcrumb-item>{{ breadcrumbTitle }}</a-breadcrumb-item>
    </a-breadcrumb>

    <div class="personal-center-content">
      <!-- 左侧菜单 -->
      <a-menu
        :defaultOpenKeys="openKeys"
        class="pc-menu"
        mode="inline"
        :selectedKeys="[selectedKey]"
        @click="handleMenuClick"
        style="width: 220px"
      >
        <template v-for="menu in menus">
          <a-sub-menu v-if="menu.children" :key="menu.path">
            <span slot="title" class="menu-title">
              <a-icon :type="menu.icon || 'menu'" />
              <span class="menu-text">{{ menu.title }}</span>
            </span>

            <!-- 递归渲染子菜单 -->
            <template v-for="child in menu.children">
              <template v-if="child.children">
                <a-sub-menu :key="child.path">
                  <span slot="title" class="menu-title">
                    <span class="menu-text">{{ child.title }}</span>
                  </span>

                  <a-menu-item v-for="sub in child.children" :key="sub.path">
                    <span class="menu-title">
                      <span class="menu-text">{{ sub.title }}</span>
                    </span>
                  </a-menu-item>
                </a-sub-menu>
              </template>

              <a-menu-item v-else :key="child.path">
                <span class="menu-title">
                  <span class="menu-text">{{ child.title }}</span>
                </span>
              </a-menu-item>
            </template>
          </a-sub-menu>

          <!-- 无子菜单的顶层 -->
          <a-menu-item v-else :key="menu.path + '_item'">
            <span class="menu-title">
              <a-icon :type="menu.icon || 'menu'" />
              <span class="menu-text">{{ menu.title }}</span>
            </span>
          </a-menu-item>
        </template>
      </a-menu>

      <!-- 右侧内容 -->
      <div class="right-content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import {
  asyncPersonRouterMap,
  asyncCompanyRouterMap,
} from "@/router/router.config";
import { scrollToTop } from "@/utils/util";
export default {
  name: "PersonalCenter",
  data() {
    return {
      // 使用 router 数据
      menus: [],
      openKeys: [],
    };
  },
  computed: {
    selectedKey() {
      return this.$route.path;
    },
    breadcrumbTitle() {
      const active = this.findMenuTitle(this.menus, this.selectedKey);
      return active ? active.title : "";
    },
  },
  created() {
    this.buildMenusAndlistOpenKeys();
  },
  methods: {
    buildMenusAndlistOpenKeys() {
      const accountType = store.getters.accountType;
      if (accountType) {
        let asyncRouterMap = [];
        if (accountType === 5) {
          asyncRouterMap = asyncPersonRouterMap;
        } else if (accountType === 13) {
          asyncRouterMap = asyncCompanyRouterMap;
        }
        //获取菜单muen
        const transform = (routes) => {
          return routes.map((r) => {
            const item = {
              title: r.meta?.title || r.path,
              icon: r.meta?.icon,
              path: r.path,
            };
            if (r.children) item.children = transform(r.children);
            return item;
          });
        };
        const personalCenterRoutes =
          asyncRouterMap?.[0]?.children?.[0]?.children || [];
        this.menus = transform(personalCenterRoutes);
        //获取默认展开项递归
        const listopenKeysDfs = (routers, openKeys = []) => {
          routers.forEach((route) => {
            if (route.children && route.children.length > 0) {
              openKeys.push(route.path);
              listopenKeysDfs(route.children, openKeys);
            }
          });
          return openKeys;
        };

        this.openKeys = listopenKeysDfs(personalCenterRoutes);
      }
    },

    //面包屑
    findMenuTitle(menus, path) {
      for (const menu of menus) {
        if (menu.path === path) return menu;
        if (menu.children) {
          const found = this.findMenuTitle(menu.children, path);
          if (found) return found;
        }
      }
      return null;
    },

    handleMenuClick({ key }) {
      this.$router.push(key);
      this.$nextTick(() => {
        scrollToTop(this);
      });
    },
  },
};
</script>

<style scoped>
.personal-center-container {
  width: 96%;
  margin: 0 auto;
  padding: 24px;
}
.personal-center-content {
  display: flex;
  background: #f5f5f5;
  padding: 16px;
  border-radius: 8px;
  min-height: 700px;
}
.right-content {
  flex: 1;
  margin-left: 16px;
  background: #fff;
  padding: 16px;
  border-radius: 8px;
  box-sizing: border-box;
  overflow-x: auto;
}
.menu-title {
  display: flex;
  align-items: center;
}
.menu-text {
  margin-left: 8px;
}
</style>
